'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _PageDescription = require('./PageDescription.component');

var _PageDescription2 = _interopRequireDefault(_PageDescription);

require('../styles/Dot.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dot = function (_BcReactComponent) {
  _inherits(Dot, _BcReactComponent);

  function Dot() {
    _classCallCheck(this, Dot);

    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
  }

  _createClass(Dot, [{
    key: 'focus',
    value: function focus() {
      this._button.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          handleClick = _props.handleClick,
          active = _props.active,
          page = _props.page,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems;

      var classnames = (0, _classnames2.default)('cp-dot', {
        active: active
      });

      return _react2.default.createElement(
        _baseButtons.Button,
        {
          ref: function ref(el) {
            return _this2._button = el;
          },
          className: classnames,
          handleClick: handleClick },
        _react2.default.createElement(_baseIcons.Dots.Empty, null),
        _react2.default.createElement(_baseIcons.Dots.Full, null),
        _react2.default.createElement(_PageDescription2.default, {
          page: page,
          pageSize: pageSize,
          numberOfItems: numberOfItems })
      );
    }
  }]);

  return Dot;
}(_baseBcReactComponent2.default);

exports.default = Dot;


Dot.propTypes = {
  active: _react.PropTypes.bool,
  handleClick: _react.PropTypes.func,
  page: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/Dot.component.js
// module id = 1398
// module chunks = 1